import { gql } from '@apollo/client';

export const createCheckoutHealthOffer = gql`
  mutation createCheckoutHealthOffer($id: String!, $input: CreateOfferInput!) {
    createHealthOffer(id: $id, input: $input)
  }
`;
